import SearchLessonByModuleRequestModelBase from '../_generated/modelBases/search-lesson-by-module-request-model-base';

export default class SearchLessonByModuleRequestModel extends SearchLessonByModuleRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
